module.exports = __webpack_public_path__ + "img/index_logo.f8220691.png";